<template lang="html">
  <div class="container">
    “兑换券”开发中
  </div>
</template>

<script>

  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
      };
    },
    computed: {
    },
    methods: {
    },
    mounted () {
    },
    destroyed () {
    }
  }
</script>

<style lang="css" scoped>
  
</style>
